export default "__VITE_ASSET__BoUe7Cu9__"